/* eslint-disable */
const ParticlesConfig = {
    autoplay: true,
    fullScreen: {
      enable: true,
      zIndex: -1
    },
    background: {
      color: {
        value: "transparent"
      }
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onClick: {
          enable: true,
          mode: "push"
        },
        onHover: {
          enable: true,
          mode: "repulse"
        },
        resize: true
      },
      modes: {
        bubble: {
          distance: 400,
          duration: 2,
          opacity: 0.8,
          size: 40
        },
        push: {
          quantity: 1
        },
        repulse: {
          distance: 50,
          duration: 0.4
        }
      }
    },
    particles: {
      color: {
        value: "#777"
      },
      links: {
        color: "#777777",
        distance: 150,
        enable: true,
        opacity: 0.5,
        width: 1
      },
      collisions: {
        enable: true
      },
      move: {
        direction: "none",
        enable: true,
        outMode: "bounce",
        random: false,
        speed: 1,
        straight: false
      },
      number: {
        density: {
          enable: true,
          area: 800
        },
        value: 90
      },
      opacity: {
        value: 0.5
      },
      shape: {
        type: "circle"
      },
      size: {
        random: true,
        value: 5
      }
    },
    themes: [
      {
        name: "light",
        default: {
          value: true,
          mode: "light"
        },
        options: {
          particles: {
            color: {
              value: "#000"
            }
          }
        }
      },
      {
        name: "dark",
        default: {
          value: true,
          mode: "dark"
        },
        options: {
          particles: {
            color: {
              value: "#06f1ff"
            }
          }
        }
      }
    ],
    detectRetina: true
  };
  export default ParticlesConfig;
  